import HotToast from 'react-hot-toast';

export function useHotToast() {
  return HotToast;
}
